import { useQuery } from '@tanstack/react-query';

import { venueGetShopifyStoreConnectionApi } from '../../../api/shopify/venueGetShopifyStoreConnectionApi';
import { VenueGetShopifyStoreConnectFilter } from '../../../graphql/API';

export const useVenueGetShopifyStoreConnectionQuery = (
  filters: VenueGetShopifyStoreConnectFilter,
) => {
  const { data, isFetching, isError, isLoading } = useQuery({
    queryKey: ['venue-shopify-store-connection', { ...filters }],
    queryFn: async ({ queryKey }) => {
      const [, filters] = queryKey as [string, VenueGetShopifyStoreConnectFilter];

      return venueGetShopifyStoreConnectionApi(filters);
    },
    refetchOnWindowFocus: false,
    enabled: !!filters.venueID,
  });
  return { data, isFetching, isError, isLoading };
};
